import React, { Component } from 'react';
import IntroText from './IntroText';
class SidePanel extends Component {
    constructor(props) {
        super(props);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            document.body.style.overflow = 'hidden';
            window.addEventListener('keydown', this.onKeyDown);
        }
        if (prevProps.open && !this.props.open) {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', this.onKeyDown);
        }
    }

    componentWillUnmount() {
        document.body.style.overflow = '';
        window.removeEventListener('keydown', this.onKeyDown);
    }

    onOverlayClick(e) {
        if (e.target === e.currentTarget && this.props.onClose) this.props.onClose();
    }

    onKeyDown(e) {
        if (e.key === 'Escape' && this.props.onClose) this.props.onClose();
    }

    render() {
        const { open, title = 'List display options', width = 375, children, onClose, introText, introTextClass } = this.props;
        return (
            <div className={'sp-root'}>
                <div
                    className={'sp' + (open ? ' sp--open' : '')}
                    onClick={this.onOverlayClick}
                    aria-hidden={!open}
                >
                    <aside
                        className={'sp__panel' + (open ? ' sp__panel--open' : '')}
                        style={{ width: width }}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="sp-title"
                    >
                        <header className="sp__header">
                            <h1 className="roomView__title">{title}</h1>
                            <div className="sp__cancel" onClick={onClose}>
                                <span className='spark-icon--fill spark-icon-close'></span>
                            </div>
                            <IntroText text={introText} className={introTextClass}/>
                        </header>


                        <div className="sp__body">{children}</div>
                    </aside>
                </div>
            </div>
        );
    }
}

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/modals/sidePanel/rightSidePanel.js